export const SIDEBAR_WIDTH = 240;

export const MOBILE_DEVICE_BREAKPOINT = 768;

export const MINIMAL_LOGO_BREAKPOINT = 500;

export const ESCAPE_KEY_CODE = 27;

export const DRAWER_MOUNT_POINT_NAME = 'drawer';
